export const dataType = {
    movement: 'MOVEMENT',
    teleports: 'TELEPORTS',
    collect: 'COLLECTIBLES'
};
